export default "__VITE_ASSET__gsfpBiVx__"